export enum Navegacoes {
  DadosPessoais = 'dados-pessoais',
  Contato = 'contato',
  Residencia = 'residencia'
}

export type TipoDadosDoFormulario = { [key: string]: any }
